import * as yup from 'yup';
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from '@Shared/utils/validationSchema';

export interface IConsultationLogFormMeta {
  user: FormInputMeta,
  from: FormInputMeta,
  to: FormInputMeta,
  schema: any,
}

const ConsultationLogFormMeta: IConsultationLogFormMeta = {} as IConsultationLogFormMeta;

ConsultationLogFormMeta.user = {
  label: 'User',
  name: 'user',
  options: [
    {
      label: 'Paul Biya',
      value: 'paul-biya',
    },
  ],
};

ConsultationLogFormMeta.from = {
  label: 'From',
  name: 'from',
  placeholder: 'From',
  validation: yup.string().required(),
}

ConsultationLogFormMeta.to = {
  label: 'To',
  name: 'to',
  placeholder: 'To',
  validation: yup.string().required(),
}

const validationSchema = getValidationSchema(ConsultationLogFormMeta);
ConsultationLogFormMeta.schema = yup.object().shape(validationSchema);

export default ConsultationLogFormMeta;
